// Header.js
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 1024);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const isScrolled = scrollY > 10;
      
      setScrolled(isScrolled);
      
      // Force update the header element directly
      const header = document.getElementById('navbar');
      if (header) {
        // Only transparent at top of home page, otherwise always #EFFBE6
        if (isHomePage && !isScrolled) {
          header.style.setProperty('background-color', 'transparent', 'important');
          header.style.setProperty('box-shadow', 'none', 'important');
        } else {
          header.style.setProperty('background-color', '#EFFBE6', 'important');
          header.style.setProperty('box-shadow', '0 2px 20px rgba(0, 0, 0, 0.1)', 'important');
        }
      }
    };
    
    // Simple scroll listener
    window.addEventListener('scroll', handleScroll);
    
    // Check initial position
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const handleOverlayClick = (event) => {
    if (event.target.classList.contains('mobile-menu')) {
      closeMenu();
    }
  };

 // Header.js (only the return part changes slightly)
return (
  <nav id="navbar" className={`site-header ${scrolled ? 'scrolled' : ''}`}>
    <div className="nav-inner">
      <Link to="/" className="logo-link">
        <div className="logo-area" data-aos="fade-up">
          <img src={logo} alt="Logo" className="logo-img" />
          <span className="site-title">Adept Knowledge Technologies</span>
        </div>
      </Link>

      {isMobile ? (
        <>
          <div
            className={`hamburger ${menuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
          >
            <span />
            <span />
            <span />
          </div>

          <div
            className={`mobile-menu ${menuOpen ? 'show' : ''}`}
            onClick={handleOverlayClick}
          >
            <nav className="mobile-nav">
              <ul className="mobile-nav-links">
                <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                <li><Link to="/about" onClick={closeMenu}>About</Link></li>
                <li><Link to="/teams" onClick={closeMenu}>Our Teams</Link></li>
                <li><Link to="/knowledge-hub" onClick={closeMenu}>Knowledge Hub</Link></li>
                <li><Link to="/careers" onClick={closeMenu}>Careers</Link></li>
                <li>
                  <Link to="/contact" onClick={closeMenu} className="nav-cta">
                    Get In Touch
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </>
      ) : (
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/teams">Our Teams</Link></li>
          <li><Link to="/knowledge-hub">Knowledge Hub</Link></li>
          <li><Link to="/careers">Careers</Link></li>
          <li>
            <Link to="/contact" className="nav-cta">Get In Touch</Link>
          </li>
        </ul>
      )}
    </div>
  </nav>
);
};

export default Header;
